import {
  Label1
} from '@redoute/labels'
import styled from '@emotion/styled'

const Label = styled(Label1)`
  font-size: 11px;
  font-weight: 600;
`

// @TODO ce sont les mêmes styles que ParagraphSmallCaps
const Label2 = styled(Label)`
  font-size: 11px;
  line-height: 120%;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
`

export { Label, Label2 }
